EHDI = EHDI || Object.create(null);

EHDI.popup = EHDI.popup || Object.create(null);

EHDI.popup.AchievementPopup = function() {
    EHDI.aka.Container.call(this);

    var _this = this;
    
    var _notifContainer,
        _notifIcon,
        _notifText,
        _isActive = false;
    
    var _notifTimeline = new TimelineMax( { autoRemoveChildren: true } );
    
    var createNotif = function(){
        _notifContainer = new EHDI.aka.Sprite( EHDI.Assets.images[ "con_achievement_in_blank" ] );
        _notifContainer.anchor.set( 0.5, 0.5 );
        _notifContainer.position.y = EHDI.screen.viewHeight * 0.625;
        _this.addChild( _notifContainer );
        
        _notifIcon = new EHDI.aka.Sprite( EHDI.Assets.images[ "achieve_first" ] );
        _notifIcon.anchor.set( 0.5, 0.5 );
        _notifIcon.position.x = _notifContainer.width * -0.38;
        _notifContainer.addChild( _notifIcon );
        
        _notifText = new EHDI.aka.PixiText( EHDI.localization.strings["achievebase"].content, {
            fontFamily: "nuevastd-bold", 
            fontSize: EHDI.localization.strings["achievebase"].size, 
            align: 'left',
            wordWrap: true,
            wordWrapWidth: _notifContainer.width * 0.65,
            fill: '#000000' 
        });
        _notifText.anchor.set( 0.0, 0.5 );
        _notifText.position.x = _notifIcon.position.x + _notifIcon.width * 0.525;
        _notifContainer.addChild( _notifText );
        
        _notifContainer.scale.set( 0.75 ); // temp
    }
    
    this.showNotification = function( data ){
        EHDI.GAME.achieveManager.checkAllUnlocked();
        
        _notifTimeline
            .addCallback( function( icon, label, active, data ){
                icon.texture = EHDI.Assets.images[ data.icon ];
                label.text = EHDI.localization.strings[ "achieve_name_" + data.id ].content;
                active = true;
            }, "+=0", [_notifIcon, _notifText, _isActive, data] )
            .add( TweenMax.to( _notifContainer, 0.25, {y: EHDI.screen.viewHeight * 0.325} ) )
            .add( TweenMax.to( _notifContainer, 0.25, {y: EHDI.screen.viewHeight * 0.625} ), "+=1.3" )
            .addCallback( function( container, active ){
                active = false;
                container.position.y = EHDI.screen.viewHeight * 0.625;
            }, "+=0", [_notifContainer, _isActive] );
    }
    
    this.pauseTimeline = function( status ){ _notifContainer.visible = !status; }
    
    this.onScreenResize = function() {
        if( !_isActive ) _notifContainer.position.y = EHDI.screen.viewHeight * 0.625;
    }
    
    createNotif();
};

EHDI.popup.AchievementPopup.prototype = Object.create(EHDI.aka.Container.prototype);